import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExternalLibrariesModule } from '../external-libraries/external-libraries.module';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { ToastrModule } from 'ngx-toastr';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { allComponents } from './components/all-export';
import { allPipes } from './pipes/all.exports';
import { NgxEchartsModule } from 'ngx-echarts';

@NgModule({
  declarations: [
    ...allComponents,
    ...allPipes,
  ],
  imports: [
    CommonModule,
    ExternalLibrariesModule,
    RouterModule,
    ReactiveFormsModule,
    MatDialogModule,
    FormsModule,
    NgxDaterangepickerMd.forRoot(),
    ToastrModule.forRoot({
      closeButton: true
    }),
    NgxEchartsModule.forRoot({
      echarts: () => import('echarts')
    })
  ],
  exports: [
    ...allComponents,
    ...allPipes
  ]
})
export class SharedModule { }
